module.exports = __webpack_public_path__ + "website/img/oa1.d67bfccb.png";